var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('b-card-title',[_vm._v("Company Summary")]),_c('p',{staticClass:"px-1"},[_vm._v(" "+_vm._s(_vm.companyData.company_summary ? _vm.companyData.company_summary : 'No summary')+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }